import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { ExternalJobDisplayInputDto } from 'src/app/shared/models/external-job-display-input.dto';
import { ExternalJobDisplayPayIntroDto } from 'src/app/shared/models/external-job-display-pay-intro.dto';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { ExternalJobDisplayService } from 'src/app/shared/services/external-job-display.service';
import { JobDetails } from '../../../models/job-details.model';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { JobState } from '../../store/state/job-details.state';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-rates',
    templateUrl: './locums-recruiter-rates.component.html',
    styleUrls: ['./locums-recruiter-rates.component.scss']
})
export class LocumsRecruiterRatesComponent implements OnInit {
    @Input() id: number;
    @Input() displayConfigData: ExternalJobDisplayInputDto;

    job: JobDetails;

    nightCallBillRateTypeDisplay = '';
    payFormatPeriodSpecification = '';
    payRangePeriodSpecification = '';
    weekendCallPeriodSpecification = '';
    payFormat = '';
    externalJobDisplayPayIntros: ExternalJobDisplayPayIntroDto[] = [];
    introTextRange = 'Range';
    payShiftTypes: Lookup[] = [
        { id: 1, name: 'Per Hour' },
        { id: 2, name: 'Per Shift' },
        { id: 3, name: 'Per Day' },
        { id: 4, name: 'Per Week' },
        { id: 7, name: 'Per Weekend' },
        { id: 5, name: 'Per Year' },
        { id: 6, name: 'Per Contract' }
    ];

    constructor(
        private readonly _store: Store<JobState>,
        private readonly externalJobDisplayService: ExternalJobDisplayService
    ) {}

    ngOnInit(): void {
        this._store
            .select(jobDetailsLoaded)
            .pipe(untilDestroyed(this))
            .subscribe((e) => {
                if (e.success) {
                    this.job = e.job;
                    this.updateNightCallBillRateTypeDisplay();
                    this.updateLabelsAndPeriodSpecification();
                }
            });

        if (this.displayConfigData && this.displayConfigData.hidePayFormat === false) {
            this.externalJobDisplayService
                .getPayIntros()
                .pipe(untilDestroyed(this))
                .subscribe((payIntros: ExternalJobDisplayPayIntroDto[]) => {
                    if (payIntros) {
                        this.externalJobDisplayPayIntros = payIntros;
                        this.payFormat = this.externalJobDisplayService.updatePayFormatDisplay(
                            this.externalJobDisplayPayIntros,
                            this.payShiftTypes,
                            this.displayConfigData
                        );
                    }
                });
        }
    }

    updateNightCallBillRateTypeDisplay(): void {
        this.nightCallBillRateTypeDisplay = LocumsUtility.getNightCallBillRateTypeString(
            this.job?.additionalBillRate?.nightCallBillRateType
        );
    }

    updateLabelsAndPeriodSpecification(): void {
        this.weekendCallPeriodSpecification = '/hour';
        this.payFormatPeriodSpecification = LocumsUtility.getPayFormatPeriodSpecification(this.job?.payPeriodTypeId);
        this.payRangePeriodSpecification = LocumsUtility.getPayRangePeriodSpecification(this.job?.payPeriodTypeId);
    }
}
